export const settingsRoutes = {
  settingsIndexRoute: '/settings',
  generalAccountRoute: '/settings/general/account',
  generalTeamsRoute: '/settings/general/teams',
  generalNotificationsRoute: '/settings/general/notifications',
  generalBillingRoute: '/settings/general/billing',
  generalPlansRoute: '/settings/general/plans',
  teamGeneralRoute: '/settings/team/general',
  teamPlansRoute: '/settings/team/plans',
  teamPlansUpgradeRoute: '/settings/team/plans/upgrade',
  teamUsersRoute: '/settings/team/users',
  teamNotificationsRoute: '/settings/team/notifications',
  teamUsageRoute: '/settings/team/usage',
  productsTargetMarketRoute: '/settings/products/target-market',
  productsVisitorReportRoute: '/settings/products/visitor-report',
  apiKeysRoute: '/settings/api/keys',
  apiLogsRoute: '/settings/api/logs',
  apiUsageRoute: '/settings/api/usage',
  apiDocsRoute: 'https://dashboard.clearbit.com/docs',
};
